import colors from '@o2/ui/theme/colors';
import { styled } from '@mui/material';

const Divider = styled('hr', {
  name: 'AppBarInternal',
  slot: 'Divider',
})(() => ({
  border: 'none',
  borderLeft: `1px solid ${colors.transparentWhite['100']}`,
  height: 24,
  margin: 0,
}));

Divider.displayName = 'AppBarInternal.Divider';

export default Divider;
